import styled from 'styled-components';

export const StarList = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`;
export const CardRatingText = styled.span`
    font-family: "Jost", sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #333333; 
`;

export const SerchpageText = styled.div`
.rating-col {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: left;
    margin-top: 0px;
}
`;